import React from 'react';
import { withTheme } from 'emotion-theming';
import { UserImage } from '@lyearn-team/frontend-components';

import * as s from './styles';

function ChatMessage(props) {
  const { chat, theme, currentUser } = props;

  const { user, message } = chat;

  const isSelf = user.id === currentUser.id;
  const userName = isSelf ? 'You' : user.name;

  return (
    <div className={s.chat(theme, isSelf)}>
      <div className={s.chatImage}>
        <UserImage name={user.name} url={user.picture} />
      </div>
      <div className={s.chatDetails}>
        <div className={s.chatName(theme, isSelf)}>{userName}</div>
        <div className={s.chatText}>{message}</div>
      </div>
    </div>
  );
}

export default withTheme(ChatMessage);
